class ChatMessageDto {

    Role: string;
    Content: string;

    constructor(role: string, content: string) {
        this.Role = role;
        this.Content = content;
    }
}

export default ChatMessageDto;
